import { render, staticRenderFns } from "./ToggleGroup.vue?vue&type=template&id=be1f5480"
import script from "./ToggleGroup.vue?vue&type=script&lang=js"
export * from "./ToggleGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports